/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Button, HFlow, Modal, ModalBody, ModalFooter, Text, VFlow } from 'bold-ui'
import { FooterButton } from 'components/footer-button'
import { HLabel } from 'components/HLabel'
import { ModalBody as ModalBodyPec } from 'components/modals/ModalBody'
import theme from 'config/theme'
import copy from 'copy-to-clipboard'
import { noop } from 'lodash'
import { isUndefinedOrNull } from 'util/checks'

export type ChaveAssinatura = {
  chave: string
}

interface ChaveAssinaturaGeradaModalProps {
  isOpen: boolean
  chaveAssinatura: ChaveAssinatura
  onClose: () => void
}

export function ChaveAssinaturaGeradaModal(props: Readonly<ChaveAssinaturaGeradaModalProps>) {
  const { isOpen, chaveAssinatura, onClose } = props

  if (isUndefinedOrNull(chaveAssinatura)) return null

  const { chave } = chaveAssinatura

  const clipBoardText = `Chave de assinatura: ${chave}`

  const handleCopy = () => {
    copy(clipBoardText)
  }

  return (
    <Modal open={isOpen} size='small' hasCloseIcon={false} closeOnBackdropClick={false} onClose={noop}>
      <ModalBody>
        <ModalBodyPec title='Chave de assinatura' titleLevel={1} icon='exclamationTriangleOutline' type='alert'>
          <VFlow>
            <Text>
              A URL do sistema externo e seus parâmetros serão assinados com a chave abaixo. A informação da chave de
              assinatura só será exibida uma vez e não será possível recuperá-la. Certifique-se de que ela estará
              segura. Em caso de perda da chave, será necessário inativar e recadastrar o sistema externo.
            </Text>

            <div css={styles.chaveBox}>
              <HLabel title='Chave:' style={styles.chaveItem}>
                {chave}
              </HLabel>
            </div>

            <HFlow justifyContent='flex-end'>
              <Button kind='primary' size='small' onClick={handleCopy}>
                Copiar
              </Button>
            </HFlow>
          </VFlow>
        </ModalBodyPec>
      </ModalBody>
      <ModalFooter>
        <HFlow justifyContent='flex-end'>
          <FooterButton kind='primary' onClick={onClose}>
            Finalizar
          </FooterButton>
        </HFlow>
      </ModalFooter>
    </Modal>
  )
}

const styles = {
  chaveBox: css`
    border: 1px solid ${theme.pallete.gray.c80};
    border-radius: 1px;
    background: ${theme.pallete.gray.c90};
  `,
  chaveItem: css`
    padding: 0.375rem 0.5rem;
  `,
}
